<template>
  <span class="">
    <!-- Social Media Icons -->
    <span v-if="linkIcons.length > 0">{{label}}</span>
    <span v-for="item in linkIcons"  :key="item.name" class="ma-1 title" >
      <v-icon style="cursor: pointer; vertical-align: middle;" class="ma-0" size="lg" fixed-width v-on:click="goto(item)">{{item.name}}</v-icon>
    </span>
</span>

</template>

<script>

export default {
  name: 'SocialMediaLinks',
  components: {
  },
  props: {
    public_settings: {
      required: true
    },
    label: {
      required: false,
      default: null
    }
  },
  computed: {
    facebookLink () { return this.public_settings.facebookLink },
    instagramLink () { return this.public_settings.instagramLink },
    twitterLink () { return this.public_settings.twitterLink },
    youtubeLink () { return this.public_settings.youtubeLink },
    pinterestLink () { return this.public_settings.pinterestLink },
    vimeoLink () { return this.public_settings.vimeoLink },
    linkIcons () {
      const icons = []
      if (this.facebookLink) {
        icons.push(
          {'name': this.$vuetify.icons.facebook,
            'link': 'https://facebook.com/' + this.facebookLink
          })
      }
      if (this.instagramLink) {
        icons.push(
          {'name': this.$vuetify.icons.instagram,
            'link': 'https://instagram.com/' + this.instagramLink
          })
      }
      if (this.twitterLink) {
        icons.push(
          {'name': this.$vuetify.icons.twitter,
            'link': 'https://twitter.com/' + this.twitterLink
          })
      }
      if (this.youtubeLink) {
        icons.push(
          {'name': this.$vuetify.icons.youtube,
            'link': 'https://youtube.com/' + this.youtubeLink
          })
      }
      if (this.pinterestLink) {
        icons.push(
          {'name': this.$vuetify.icons.pinterest,
            'link': 'https://pinterest.com/' + this.pinterestLink
          })
      }
      if (this.vimeoLink) {
        icons.push(
          {'name': this.$vuetify.icons.vimeo,
            'link': 'https://vimeo.com/' + this.vimeoLink
          })
      }

      return icons
    }
  },
  data () {
    return {
      show: false,
      inprogress: false,
      updateSuccess: false,
      errMessage: null,
      siteLinks: 'NOT SET YET'

    }
  },

  methods: {
    goto: function (item) {
      window.open(item.link, '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
